<template>
    <v-card class="elevation-10">
        <v-card-title style="background:#6499faff; color: white;">{{ $t('coach.formTitle') }}</v-card-title>
        <v-card-text>
            <v-form :readonly="readOnly">
                <v-row>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="coach.name"
                            :label="$t('field.firstName')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="coach.lastName"
                            :label="$t('field.lastName')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="coach.mobile"
                            :label="$t('field.mobilePhone')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="coach.email"
                            :label="$t('field.email')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="12">
                        {{ $t('coach.addPayment') }}
                        <v-btn icon color="primary" @click="coach.payments.push({})">
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col v-for="(payment, index) in coach.payments" :key="`payment-${index}`" cols="12">
                        <v-row align="center">
                            <v-col cols="1">
                                <v-btn icon color="primary" @click="coach.payments.splice(index, 1)">
                                    <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="10">
                                <coach-payment :payment="payment" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions v-if="mode !== 'show'" class="submit-button-wrapper">
            <v-btn :loading="loading" class="mx-2 white--text" :disabled="shouldDisableSubmit()" large color="black" @click="onSubmit">
                {{ $t('button.submit') }}
            </v-btn>
            <v-btn class="mx-2 white--text" large color="red" @click="$router.go(-1)">
                {{ $t('button.cancel') }}
            </v-btn>
        </v-card-actions>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-card>
</template>

<script>
    import coachService from '@/services/coach'
    import Alert from '@/components/Alert'
    import CoachPayment from '@/forms/CoachPayment'

    export default {
        name: 'CoachForm',
        components: { Alert, CoachPayment },
        data: () => {
            return {
                showAlert: false,
                dialog: false,
                message: null,
                type: null,
                mode: null,
                readOnly: false,
                clearable: true,
                loading: false,
                startDate: null,
                endDate: null,
                coach: { payments: [] },
                mandatoryField: [
                    v => !!v || 'Field is required'
                ],
                search: null
            }
        },
        computed: {
        },
        watch: {
            search() {
                if (this.search.length > 0) {
                    this.fetchFilteredCoaches()
                }
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            if (this.$route.params.coachId) {
                coachService.getCoach(this.$route.params.coachId).then(resp => {
                    this.coach = resp.data
                })
            }
        },
        methods: {
            updateCoach() {
                this.dialog = false
                coachService.getCoach(this.$route.params.coachId).then(resp => {
                    this.coach = resp.data
                })
            },
            openDialog(data) {
                this.dialog = true
            },
            getCoachText(item) {
                return `${item.name} ${item.lastName}`
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            shouldDisableSubmit() {
                return false
            },
            onEdit() {
                this.$router.push(`/coaches/${this.coach.id}/edit`)
            },
            createCoach() {
                coachService.createCoach(this.coach).then(coachResponse => {
                    this.loading = false
                    this.$router.push(`/coaches`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            editCoach() {
                coachService.updateCoach(this.$route.params.coachId, this.coach).then(coachResponse => {
                    this.loading = false
                    this.$router.push(`/coaches`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            async onSubmit() {
                this.loading = true
                if (this.mode === 'edit') {
                    this.editCoach()
                } else if (this.mode === 'create') {
                    this.createCoach()
                } else {
                    this.createCoach()
                }
            }
        }

    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.v-menu__content{
    background-color: white!important;
    overflow-y: hidden!important;
}
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.img-preview {
    max-width: 70%;
    margin: 0 auto;
}

.image-input {
    padding: 20px;
    width: 100%;
    border-style: groove;
    border: #D3D3D3 solid 2px;
    border-radius: 15px 50px;
    margin-top: 1vh;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
